import { genericCollectionSlice } from 'helpers/state/generic-collection.slice';

const { slice: usersSlice } = genericCollectionSlice('user');

export const { addUser } = usersSlice.actions;

export default usersSlice.reducer;
